import { store } from 'v3/data/store';
import { deviceSlice } from '.';
import { IDevice } from './types';

export const setDevice = (device: IDevice) => {
  store.dispatch(deviceSlice.actions.setDevice(device));
};
